"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bookmarkedBubbleClass = {
    borderRadius: '50%',
    backgroundColor: 'primary.main',
    width: '20px',
    height: '20px',
    textAlign: 'center',
    color: 'white',
    fontSize: '12px',
    lineHeight: '19px',
};
exports.default = bookmarkedBubbleClass;
